import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as dayjs from 'dayjs';

@Pipe({
  name: 'convertDateToTime',
  standalone: true,
})
export class ConvertDateToTimePipe implements PipeTransform {
  constructor(private translate: TranslateService) { }

  transform(dateTimeValue: any, args?: any): any {

    const dateTime = dayjs(dateTimeValue);

    if (!dateTimeValue || !args) return '-';

    const now = dayjs();

    const diffInMinutes = now.diff(dateTime, 'minutes');

    // Less than 2 minutes
    if (diffInMinutes < 2) return this.translate.instant('messages.momentsAgo');

    // Between 2 and 5 minutes
    if (diffInMinutes >= 2 && diffInMinutes < 5) {
      const timeMin = this.translate.instant('messages.fewMinutesAgo');
      return timeMin;
    }

    // More than 5 minutes and less than 1 hour
    if (diffInMinutes >= 5 && diffInMinutes < 60) {
      const timeMin = this.translate.instant('messages.fewMinutesAgoWithMin', {
        min: diffInMinutes,
      });
      return timeMin;
    }

    // More than 1 hour and less than 1 day
    if (diffInMinutes >= 60 && diffInMinutes < 1440) {
      const hours = Math.floor(diffInMinutes / 60);
      return this.translate.instant('messages.hoursAgo', { hours });
    }

    // More than 1 day
    const days = now.diff(dateTime, 'days');
    if (1 <= days && days <= 30) {
      return this.translate.instant('messages.daysAgo', { days });
    }

    // More than 1 month
    const month = now.diff(dateTime, 'month');
    if (1 <= month && month <= 12) {
      return this.translate.instant('messages.monthsAgo', { month });
    }

    // More than 1 month
    return '-';
    const year = now.diff(dateTime, 'year');
    if (1 <= year) {
      return this.translate.instant('messages.yearsAgo', { year });
    }
    else {
      return dateTime.format('HH:mm');
    }
  }
}
